import { create } from "zustand";
import { DesktopsSlice, createDesktopsStore } from "./desktops.store";

export const useDesktopsStore = create<DesktopsSlice>((...args) => ({
	...createDesktopsStore(...args),
}));
